<template>
	<Dialog
		:dialog-visible="modelValue"
		title="Add session to a project"
		:options="{ width: '600px' }"
		:remove-agree-button="true"
		:cancel-text="'Close'"
		:persistent-dialog="true"
		:custom-outside-click-function="ignoreOutsideDismissal"
		@cancel="close">
		<template #dialog-body>
			<p class="text-body-2 text-medium-emphasis mb-4">Search your projects, or create a new one.</p>
			<ProjectAutoComplete
				ref="projectPickerRef"
				:model-value="currentProject"
				:entity="conversation"
				:disabled="isSaving"
				:assignment-mode="true"
				label="Project"
				placeholder="Search projects"
				@update:model-value="selectProject" />
		</template>
	</Dialog>
</template>

<script setup lang="ts">
	import { nextTick, ref, watch } from "vue";
	import Dialog from "@/components/Dialog.vue";
	import ProjectAutoComplete from "@/components/formfields/ProjectAutoComplete.vue";
	import type { Conversation } from "@/types/Conversation";
	import type { Project } from "@/types/Project";

	const props = defineProps<{
		modelValue: boolean;
		conversation: Conversation;
		currentProject: Project | null;
		isSaving: boolean;
	}>();

	const emit = defineEmits<{
		"update:modelValue": [visible: boolean];
		select: [project: Project | null];
	}>();

	const projectPickerRef = ref<{ open?: () => void } | null>(null);

	function close(): void {
		if (!props.isSaving) emit("update:modelValue", false);
	}

	function ignoreOutsideDismissal(): void {}

	function selectProject(project: Project | string | null): void {
		if (typeof project === "string") return;
		if (!project) {
			if (props.currentProject) emit("select", null);
			return;
		}
		if (!project.id) return;
		if (project.id === props.currentProject?.id) {
			close();
			return;
		}
		emit("select", project);
	}

	watch(
		() => props.modelValue,
		async (visible) => {
			if (!visible) return;
			await nextTick();
			projectPickerRef.value?.open?.();
		}
	);
</script>
